module.exports = __webpack_public_path__ + "img/invitation.1069d424.png";